import { useCallback, useEffect, useState } from "react";
import { useUsersApi } from "../api/usersApi";

export function useUsers() {
  const api = useUsersApi();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchUsers = useCallback(async () => {
    try {
      setLoading(true);
      const data = await api.getAll();
      setUsers(data);
      setError(null);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [api]);

  const addUser = async (newUser) => {
    const created = await api.create(newUser);
    setUsers((prev) => [...prev, created]);
  };

  const updateUser = async (id, updatedUser) => {
    const saved = await api.update(id, updatedUser);

    setUsers((prev) => prev.map((u) => (u.id === id ? { ...u, ...saved } : u)));
  };

  const deleteUser = async (id) => {
    await api.remove(id);
    setUsers((prev) => prev.filter((u) => u.id !== id));
  };

  const setLeader = async (id, value) => {
    await api.setLeader(id, value);
    setUsers((prev) =>
      prev.map((u) => ({
        ...u,
        leadUser: u.id === id ? value : false,
      })),
    );
  };

  const saveOrder = async (users) => {
    const payload = users.map((u) => ({
      id: u.id,
      leadOrder: u.leadOrder,
    }));

    await api.saveOrder(payload);
  };

  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  return {
    users,
    loading,
    error,
    fetchUsers,
    addUser,
    setUsers,
    updateUser,
    deleteUser,
    setLeader,
    saveOrder,
  };
}
